export default {
  init: async () => {
    const tooltips = document.querySelectorAll("[data-tooltip]");

    if (!tooltips.length) {
      return;
    }

    const { default: tippy } = await import("tippy.js");
    await import("tippy.js/dist/tippy.css");
    await import("tippy.js/themes/light.css");

    tippy("[data-tooltip]", {
      theme: "light",
      allowHTML: true,
      content: (ref) => {
        return document.getElementById(ref.getAttribute("aria-describedby")).innerHTML;
      },
    });
  },
};
